var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"omapi-settings-page"},[_vm._t("tabs"),_vm._v("\n\n\tBilling settings\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }